import * as MuseumActions from "@Actions/museum.actions"
import { SelectedMuseumState } from "@State/app.state"
import { createReducer, on } from "@ngrx/store"

const selectedMuseumInitialState: SelectedMuseumState = {
  museum: null,
  visitsList:[],
  museumLoadError:null,
  visitLoadError:null,
  doneLoadingMuseum:false,
  doneLoadingVisits:false,
  lang: null,
  visitorInfo: {
    info: null,
    infoLang: null,
    forMuseum: null,
  }
}

export const selectedMuseumReducer = createReducer(
  selectedMuseumInitialState,
  on(MuseumActions.setSingleMuseum, (state, { museum }) => {
    return { ...state, museum };
  }),
  on(MuseumActions.singleMuseumLoadError, (state, { museumLoadError }) => {
    return { ...state, museumLoadError };
  }),
  on(MuseumActions.clearSingleMuseum, () => {
    //* svuota anche la lista di visite e gli errori
    return selectedMuseumInitialState;
  }),
  on(MuseumActions.setSingleMuseumVisitList, (state, { visitsList }) => {
    return { ...state, visitsList };
  }),
  on(MuseumActions.singleMuseumVisitListLoadError, (state, { visitLoadError }) => {
    return { ...state, visitLoadError };
  }),
  on(MuseumActions.clearVisitList, (state) => {
    return { ...state, visitsList: [] };
  }),
  on(MuseumActions.clearSingleMuseumLoadError, (state) => {
    return { ...state, museumLoadError: null };
  }),
  on(MuseumActions.clearSingleMuseumVisitListLoadError, (state) => {
    return { ...state, visitLoadError: null };
  }),
  on(MuseumActions.doneLoadingSingleMuseumInfos, (state) => {
    return { ...state, doneLoadingMuseum: true }
  }),
  on(MuseumActions.doneLoadingSingleMuseumVisits, (state) => {
    return { ...state, doneLoadingVisits: true }
  }),
  on(MuseumActions.setLanguage, (state, { lang }) => {
    return { ...state, lang };
  }),
  on(MuseumActions.setVisitorInfo, (state, { info, infoLang, forMuseum }) => {
    return { ...state, visitorInfo: { info, infoLang, forMuseum } };
  })
)
